import { CloseButtonTemplate, CloseButtonTemplateProps } from "./template";

export type CloseButtonProps = CloseButtonTemplateProps;

export const CloseButton = (props: CloseButtonProps): JSX.Element => {
  return <CloseButtonTemplate {...props} />;
};
